import React, { createContext, useContext, useEffect, ReactNode } from "react";

// 1. Define the type for the context value
type HostnameContextType = string;

// 2. Create the context with a default value
const HostnameContext = createContext<HostnameContextType>("");

// 3. Custom hook for easy access
export const useHostname = () => useContext(HostnameContext);

// 4. Provider props type
interface HostnameProviderProps {
  children: ReactNode;
}

// 5. Provider component
export const HostnameProvider: React.FC<HostnameProviderProps> = ({ children }) => {
  const hostname =
    typeof window !== "undefined" && window.location
      ? window.location.hostname
      : "";

  const hostnameClass = hostname.replace(/\./g, '-');

  useEffect(() => {
    document.body.classList.add(hostnameClass);
    return () => {
      document.body.classList.remove(hostnameClass);
    };
  }, []);

  return (
    <HostnameContext.Provider value={hostname}>
      {children}
    </HostnameContext.Provider>
  );
};

